export default {
  methods: {
    getAccountColor(value) {
      if (value < 0) return 'red';
      else if (value > 0) return 'green';
      else return 'grey';
    }
  }
};
